<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">{{ title }}</h1>
      <div class="row">
        <div class="col-xs-12">
          <div class="row">
            <section class="controls">
              <div class="col-xs-12 col-lg-6">
                <div class="form-group">
                  <v-select
                    v-model="uor"
                    :loading="loading.unidade"
                    :disabled="loading.unidade"
                    label="nome"
                    @input="loadReferencias"
                    :placeholder="unidadeLabel"
                    :options="uors"
                    :reduce="u => u.uor_sigla"
                    :selectOnTab="true"
                  >
                  <options>Nenhum selecionado</options>
                    <template #spinner="{ loading }">
                      <div
                        v-if="loading"
                        style="border-left-color: rgba(93, 197, 150, 0.71)"
                        class="vs__spinner"
                      >
                        The .vs__spinner class will hide the text for me.
                      </div>
                    </template>
                    <span slot="no-options">Desculpe, não há nenhum item.</span>
                  </v-select>
                </div>
              </div>
              <div class="col-xs-12 col-lg-6">
                <div class="form-group">
                  <v-select
                    :loading="loading.referencia"
                    :disabled="loading.referencia"
                    v-model="referencia"
                    @input="loadEscala"
                    :placeholder="referenciaLabel"
                    :options="referencias"
                    :reduce="referencia => referencia.value"
                    :selectOnTab="true"
                  >
                    <template #spinner="{ loading }">
                      <div
                        v-if="loading"
                        style="border-left-color: rgba(93, 197, 150, 0.71)"
                        class="vs__spinner"
                      >
                        The .vs__spinner class will hide the text for me.
                      </div>
                    </template>
                    <span slot="no-options">Desculpe, não há nenhum item.</span>
                  </v-select>
                </div>
              </div>
              <div class="col-xs-12">
                <button
                  :disabled="escalaStatus != 'done'"
                  @click.prevent="imprimir"
                  class="btn btn-success btn-md btn-block"
                >
                  <font-awesome-icon :icon="'print'"></font-awesome-icon>
                  <span>{{ buttonLabel }}</span>
                  <pulse-loader
                    v-show="escalaStatus == 'processing'"
                    :size="'0.5em'"
                    class="loading"
                  ></pulse-loader>
                </button>
              </div>
            </section>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12">
          <section class="print">
            <header>
              <h4>{{ print.unidade }}</h4>
              <h5>ESCALA DE {{ print.referencia }}</h5>
            </header>

            <data-table-public
              ref="escalas"
              :api-mode="false"
              :data="print.calendario"
              :fields="columns"
              :css="tableCss"
            >
            </data-table-public>

            <section v-if="print.observacao">
              <h6>OBSERVAÇÃO:</h6>
              <p>{{ print.observacao }}</p>  
            </section>

          </section>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { request } from '@/request'
import DataTablePublic from '@/components/common/DataTablePublic'

export default {
  data() {
    return {
      title: 'Imprimir Escala',
      columns: [
        {
          name: 'colaborador',
          title: 'Colaboradores',
          titleClass: 'align-middle',
          dataClass: 'column-name align-middle',
          callback: ({ nome, cargo }) => {
            let html = []
            html.push(`<span>${cargo}</span>`)
            html.push(`<p>${nome}</p>`)
            return html.join('')
          }
        }
      ],
      uor: null,
      uors: [],
      referencia: null,
      referencias: [],
      escalas: [],
      print: {
        unidade: 'Nome da unidade',
        referencia: 'Mês/Ano',
        observacao: 'Sem nenhuma observação',
        calendario: [],
      },
      loading: {
        unidade: false,
        referencia: false
      },
      escalaStatus: 'wait',
      tableCss: {
        table: {
          tableClass: 'table table-bordered table-hover',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down'
        },
        pagination: {
          wrapperClass: 'pagination pull-right',
          activeClass: 'btn-primary',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: 'glyphicon glyphicon-step-backward',
            prev: 'glyphicon glyphicon-chevron-left',
            next: 'glyphicon glyphicon-chevron-right',
            last: 'glyphicon glyphicon-step-forward'
          }
        }
      }
    }
  },
  components: {
    DataTablePublic
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.loadUors()
  },
  computed: {
    acaoIndisponivel() {
      return this.uor === null || this.referencia === null
    },
    unidadeLabel() {
      const {
        loading: { unidade }
      } = this
      return unidade ? 'Carregando as unidades...' : 'Selecione a unidade'
    },
    referenciaLabel() {
      const {
        loading: { referencia }
      } = this
      return referencia
        ? 'Carregando as referências...'
        : 'Selecione a referência'
    },
    buttonLabel() {
      switch (this.escalaStatus) {
        case 'wait':
          return 'Aguardando os dados para gerar a escala!'
          break
        case 'processing':
          return 'Gerando a escala'
          break
        case 'done':
          return 'OK clique aqui!'
          break
      }
    }
  },
  methods: {
    loadUors() {
      this.loading.unidade = true
      this.escalaStatus = 'wait'

      request
        .get('escala/listar-unidade-publicada-user')
        .then(({ data }) => {
          this.uors = data.map(({ uor_sigla, uor_nome }) => {
            return {
              uor_sigla,
              nome: uor_sigla === uor_nome ? uor_sigla : `${uor_sigla} | ${uor_nome}`
            }
          })
          this.loading.unidade = false
        })
        .catch(e => {
          console.log(e)
        })
    },
    loadReferencias() {
      if (this.uor === null) {
        this.referencia = null
        this.referencias = []
        this.escalas = []
        return
      }

      this.escalaStatus = 'wait'
      this.loading.referencia = true

      let { uor: uor_sigla } = this

      request
        .post('escala/listar-referencia-publicada', { uor_sigla })
        .then(response => {
          const { data } = response
          this.referencias = data.map(referencia => {
            const value = referencia
            const ano = value.substr(0,4);
            const mes = Number(value.substr(-2)) - 1;

            const label = new Date(ano, mes, 1).toLocaleString('pt-BR', { month: 'long', year:'numeric' }).toUpperCase()

            return { value, label }
          })
          this.loading.referencia = false
        })
        .catch(e => {
          console.log(e)
        })
    },
    loadEscala() {
      const me = this
      let { uor: uor_sigla, referencia } = me
      if (uor_sigla === null || referencia === null) {
        me.escalas = []
        return
      }

      this.escalaStatus = 'processing'
      
        request
        .get(`escala/listar-escala-uor-referencia?uor_sigla=${uor_sigla}&referencia=${referencia}`)
        .then(response => {
          this.print = response.data

          if (this.print.calendario) {
            const [firstItem] = this.print.calendario
            const { colaborador, ...rest } = firstItem
            const columnsName = Object.keys(rest)
            this.createColumns(columnsName)

            const referenciaSelecionada = this.referencias.find(referencia => referencia.value == this.referencia)
            this.print.referencia = referenciaSelecionada.label
          }
          this.escalaStatus = 'done'
        })
        .catch(e => {
          console.log(e)
        })
    },
    createColumns(columnsName) {
      // mantendo a primeira coluna de funcionarios
      this.columns = [this.columns[0]]

      columnsName.forEach(name => this.columns.push(this.createColumn(name)))

      this.$refs.escalas.normalizeFields()
    },
    createColumn(name) {
      const year = name.substr(0, 4)
      const month = name.substr(4, 2)
      const day = name.substr(6, 2)
      const date = new Date(year, parseInt(month) - 1, day)
      const weekday = date
        .toLocaleDateString('pt-BR', { weekday: 'short' })
        .toUpperCase()
        .replace('.', '')

      return {
        name,
        titleClass: 'text-center',
        title: `<span>${weekday}</span><div>${day}</div>`,
        dataClass: 'align-middle column-day',
        callback: value => {
          return Array.isArray(value)
            ? value.map(time => `<p>${time}</p>`).join('')
            : ''
        }
      }
    },
    imprimir() {
      window.print()
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
  padding: 6px !important;
}

.column-name span {
  font-size: 10px;
  color: gray;
  text-transform: uppercase;
}

.column-name p {
  width: 160px;
  font-weight: 700;
  font-size: 16px;
  margin: 0;
}

.column-day {
  white-space: nowrap;
  font-size: 9px;
  padding-left: 3px !important;
  padding-top: 8px !important;
}

section.controls {
  max-width: 800px;
}

button.btn-success {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
}

button.btn-success * {
  margin-right: 16px;
}

section.print {
  opacity: 0;
}

@media print {
  .page-print h1.page-header,
  .page-print .form-group,
  .page-print button,
  .page-print section.status {
    display: none;
  }

  section.print {
    opacity: 1;
    margin-left: -270px;
  }

  @page {
    size: landscape;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/admin/escalas/Impressao.vue